var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".user_svg__a{fill:none;stroke:#1e2022;stroke-miterlimit:10;stroke-width:2px}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    className: "user_svg__a",
    transform: "translate(9 3)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.007 15.645A11.44 11.44 0 0 0 4 26.375 27 27 0 0 0 16 29a27 27 0 0 0 12-2.625 11.44 11.44 0 0 0-8-10.73",
    className: "user_svg__a"
  })));
};
export default SvgUser;